import { objectToTreeListNode, treeListNodeToObject } from 'src/components/#common/tree-list/TreeListNode';
export function getDefaultValue(type) {
    return objectToEditable({ value: _getDefaultValue(type) }, 'variable');
}
function _getDefaultValue(type) {
    switch (type) {
        case 'string':
            return '';
        case 'number':
            return 0;
        case 'boolean':
            return false;
        case 'object':
            return {};
        case 'array':
            return [];
        default:
            throw new Error(`Unknown type ${type}`);
    }
}
/**
'', null, undefined - string
0, 1, 2 - number
false - boolean
{} - object
[] - array
*/
export function getValueType(value) {
    if (value == null) {
        return 'string';
    }
    if (typeof value === 'number') {
        return 'number';
    }
    if (typeof value === 'boolean') {
        return 'boolean';
    }
    if (typeof value === 'string') {
        return 'string';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    if (typeof value === 'object') {
        return 'object';
    }
    throw new Error(`Unknown type of value: ${typeof value}`);
}
// преобразуем объект в удобный для редактирования формат
export function objectToEditable(object, _type = 'group') {
    let objectValue;
    let type;
    if (_type === 'variable') {
        objectValue = object.value;
        type = getValueType(object.value);
    }
    else if (typeof object !== 'object' || object == null || Array.isArray(object)) {
        throw new Error(`Unexpected type of object:\r\n${JSON.stringify(object, null, 2)}`);
    }
    else {
        objectValue = object;
        type = 'object';
    }
    switch (type) {
        case 'string':
        case 'number':
        case 'boolean':
            return {
                type: type,
                description: object.description,
                value: object.value,
            };
        case 'array':
            return {
                type: type,
                description: object.description,
                value: object.value.map(o => objectToEditable(o, 'group')),
            };
        case 'object':
            return {
                type: type,
                value: Object.keys(objectValue).map((key) => {
                    const value = objectToEditable(objectValue[key], 'variable');
                    return [key, value];
                }),
            };
        default:
            throw new Error(`Unknown type ${type}`);
    }
}
// преобразуем объект обратно в серверный формат
export function editableToObject(object) {
    // arrays and objects
    if (object.type === 'array') {
        return {
            value: object.value.map(editableToObject),
            description: object.description,
        };
    }
    if (object.type === 'object') {
        return object.value.reduce((result, [key, value]) => {
            result[key] = editableToObject(value);
            return result;
        }, {});
    }
    return {
        value: object.value,
        description: object.description,
    };
}
export function categoriesToObject(categories) {
    return treeListNodeToObject(categories, (data, children) => {
        var _a, _b, _c;
        const result = {
            name: (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.name,
            description: (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.description,
        };
        const variables = (_c = data.data.variables) === null || _c === void 0 ? void 0 : _c.map((item) => {
            return editableToObject(item);
        });
        if (variables === null || variables === void 0 ? void 0 : variables.length) {
            result.variables = variables;
        }
        if (children === null || children === void 0 ? void 0 : children.length) {
            result.children = children;
        }
        return result;
    });
}
export function objectToCategories(object) {
    return objectToTreeListNode(object, (o) => o === null || o === void 0 ? void 0 : o.children, (o) => {
        return {
            data: o && {
                name: o.name,
                description: o.description,
                variables: (o.variables || []).map((item) => {
                    return objectToEditable(item);
                }),
            },
        };
    });
}
